import {
  TENANT_AT,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts/tenants'
import { freeShippingIndicatorExperiment } from 'shared/experiments/consts/experimentsToInject'
import { type Experiment } from 'types/shopConfig'

import {
  PDP_VARIANTS_POSITION,
  RELEASE_SWITCH_TOGGLE,
  RELEASE_SWITCH_TOGGLE_AT,
} from './names'
import type { ExperimentName } from './types'

export const RELEASE_SWITCH_TOGGLES: Record<string, ExperimentName> = {
  [TENANT_COM]: RELEASE_SWITCH_TOGGLE,
  [TENANT_AT]: RELEASE_SWITCH_TOGGLE_AT,
  default: RELEASE_SWITCH_TOGGLE,
}

/**
 * List of experiments that are manually activated.
 *
 * Add the experiment name here if the experiment is something like AA test or
 * there is no `<Experiment name=... />` part
 */
export const MANUALLY_ACTIVATED: ExperimentName[] = [
  RELEASE_SWITCH_TOGGLE,
  RELEASE_SWITCH_TOGGLE_AT,
  PDP_VARIANTS_POSITION,
]

/**
 * List of experiments that are manually injected.
 * this is used for the experiments that are tested and activated for some tenants
 * but still needs to be ab tested in other tenants so we need the experiment code
 */
export const MANUALLY_INJECTED_EXPERIMENTS: Record<string, Experiment[]> = {
  [TENANT_COM]: [freeShippingIndicatorExperiment],
  [TENANT_AT]: [freeShippingIndicatorExperiment],
  [TENANT_IT]: [freeShippingIndicatorExperiment],
  [TENANT_FR]: [],
  [TENANT_CH]: [],
}
